import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AdvancedLevel = ({
  height = 9,
  width = 35,
  color = colors.purple50,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <circle cx="4.5" cy="4.5" r="4.5" fill={getColor(color, isColorInherited)} />
    <circle cx="17.5" cy="4.5" r="4.5" fill={getColor(color, isColorInherited)} />
    <circle cx="30.5" cy="4.5" r="4.5" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
